import { createContext, useContext } from 'react';
import { IResearchEnvironmentContext } from '@vivli/features/data-requests/infrastructure/interface';

export const ResearchEnvironmentContext = createContext<IResearchEnvironmentContext>(null);

export const useResearchEnvironmentContext = () => useContext(ResearchEnvironmentContext);
